module.exports = __webpack_public_path__ + "img/2.08371938.png";